// SafeEnvironmentSection.js
import React from "react";
import { Phone } from "lucide-react";
import safeEnvironmentImage from "../assets/safe-environment-image.jpg";

const SafeEnvironmentSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Creating a Safe and Supportive Environment for Dementia Care
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                At Allawah Lodge, we prioritise creating a safe and supportive
                environment for individuals with dementia. We understand that
                the right environment plays a crucial role in promoting their
                well-being, reducing anxiety, and enhancing their quality of
                life. Our dedicated team is committed to implementing strategies
                and modifications that ensure the safety and comfort of our
                clients.
              </p>

              <p>
                Safety is paramount when it comes to dementia care. We conduct a
                comprehensive assessment of the home environment to identify
                potential hazards and implement necessary modifications. We
                address issues such as removing tripping hazards, installing
                handrails, and implementing proper lighting to reduce the risk
                of falls. Our caregivers in Coolamon, Wagga Wagga, and
                surrounding areas are trained to provide gentle guidance and
                reassurance, helping to reduce anxiety and enhance a sense of
                security.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={safeEnvironmentImage}
              alt="Caregiver with elderly woman"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafeEnvironmentSection;
